module.exports = __webpack_public_path__ + "img/bakso.f2cabeb4.jpg";